import { registerElementDefinition } from '../../services/element-definitions.service';

import { type BaseContainerDef, type BaseContainerPropsModel } from './_container.models';
import { getContainerDefinition } from './container.definition';

export type ContainerDef = BaseContainerDef<BaseContainerPropsModel>;

// Extend the CanvasElementDefinitions type
declare module '@blaze-runtime/engine-domain' {
  interface CanvasElementDefinitions {
    container: ContainerDef;
  }
}

registerElementDefinition(getContainerDefinition());
